/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InKeyPublicMultibase: core.serialization.ObjectSchema<
    serializers.InKeyPublicMultibase.Raw,
    Truvity.InKeyPublicMultibase
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace InKeyPublicMultibase {
    export interface Raw {
        values: string[];
    }
}
